/** Ярлыки значений контракта (docs/06 §6: статусы и типы не переводим на лету). */

import type { AgentRole, BoardType, GlobalRole, InvitationStatus, IssueType, Priority, ProjectRole, Resolution, SprintState, StatusCategory, Swimlane, UserKind } from '../lib/types';

export const issueTypeLabels = {
  epic: 'Эпик',
  story: 'История',
  task: 'Задача',
  bug: 'Баг',
  subtask: 'Подзадача',
} satisfies Record<IssueType, string>;

export const priorityLabels = {
  lowest: 'Низший',
  low: 'Низкий',
  medium: 'Средний',
  high: 'Высокий',
  highest: 'Высший',
} satisfies Record<Priority, string>;

export const statusCategoryLabels = {
  todo: 'К выполнению',
  in_progress: 'В работе',
  done: 'Готово',
} satisfies Record<StatusCategory, string>;

export const resolutionLabels = {
  fixed: 'Исправлено',
  wont_fix: 'Не будем исправлять',
  duplicate: 'Дубликат',
  cannot_reproduce: 'Не воспроизводится',
  done: 'Сделано',
} satisfies Record<Resolution, string>;

export const sprintStateLabels = {
  future: 'Будущий',
  active: 'Активный',
  closed: 'Завершён',
} satisfies Record<SprintState, string>;

export const swimlaneLabels = {
  none: 'Без группировки',
  assignee: 'По исполнителю',
  epic: 'По эпику',
  priority: 'По приоритету',
  component: 'По компоненту',
} satisfies Record<Swimlane, string>;

export const boardTypeLabels = {
  kanban: 'Канбан',
  scrum: 'Скрам',
} satisfies Record<BoardType, string>;

export const globalRoleLabels = {
  admin: 'Администратор',
  member: 'Участник',
} satisfies Record<GlobalRole, string>;

/** Тип сотрудника в списке админки (UC-USR-08). */
export const userKindLabels = {
  human: 'Сотрудник',
  ai_agent: 'AI агент',
} satisfies Record<UserKind, string>;

/** Специализация AI агента (UC-USR-08). */
export const agentRoleLabels = {
  analyst: 'Аналитик',
  developer: 'Разработчик',
} satisfies Record<AgentRole, string>;

/** Статусы приглашения в списке админки (UC-USR-07). */
export const invitationStatusLabels = {
  pending: 'Приглашён',
  expired: 'Ссылка истекла',
  accepted: 'Зарегистрирован',
  revoked: 'Отозвано',
} satisfies Record<InvitationStatus, string>;

/** Тон бейджа для каждого статуса приглашения. */
export const invitationStatusTones = {
  pending: 'warning',
  expired: 'danger',
  accepted: 'success',
  revoked: 'neutral',
} as const satisfies Record<InvitationStatus, 'neutral' | 'warning' | 'danger' | 'success'>;

export const projectRoleLabels = {
  project_admin: 'Администратор проекта',
  member: 'Участник',
} satisfies Record<ProjectRole, string>;

/** Порядок типов задач в селекторах. */
export const ISSUE_TYPE_ORDER: readonly IssueType[] = ['epic', 'story', 'task', 'bug', 'subtask'];

export const PRIORITY_ORDER: readonly Priority[] = ['highest', 'high', 'medium', 'low', 'lowest'];

export const STATUS_CATEGORY_ORDER: readonly StatusCategory[] = ['todo', 'in_progress', 'done'];

export function issueTypeLabel(type: IssueType): string {
  return issueTypeLabels[type];
}

export function priorityLabel(priority: Priority): string {
  return priorityLabels[priority];
}

export function statusCategoryLabel(category: StatusCategory): string {
  return statusCategoryLabels[category];
}
